import { Component } from '@angular/core';
import { Actions } from 'bqx-deal';
import { toUpper } from 'lodash';
import { AppConfig } from 'src/app/app.config';
import { AbstractAuthService } from 'src/app/services/auth/auth.abstract.service';
import { AbstractDealAnalyticsService } from 'src/app/services/deal-analytics/abstract-deal-analytics.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css'],
  standalone: false
})
export class HeaderComponent {
  get envName(): string {
    return toUpper(AppConfig.settings?.env?.name);
  }
  get isLoggedOut(): boolean {
    return this.authService.isLoggedOut;
  }
  get clientUser(): string {
    return this.authService.currentUser;
  }

  constructor(
    private authService: AbstractAuthService, private dealAnalyticsService: AbstractDealAnalyticsService
  ) { }

  public onLogoutClick() {
    this.dealAnalyticsService.postDealControlEvent(Actions.ButtonClick, 'Logout');
    this.authService.logoutorRefresh();
  }

  public onHomeClick() {
    this.dealAnalyticsService.postDealControlEvent(Actions.ButtonClick, 'Home');
    sessionStorage.clear();
  }
}
